import { render, staticRenderFns } from "./AbilityScoreCard.vue?vue&type=template&id=129c0228&scoped=true&"
import script from "./AbilityScoreCard.vue?vue&type=script&lang=js&"
export * from "./AbilityScoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c0228",
  null
  
)

export default component.exports